import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-footer',
  templateUrl: './ramadan20-footer.component.html',
  styleUrls: ['./ramadan20-footer.component.css']
})
export class Ramadan20FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
